import moment, { MomentInput } from 'moment';
import { Day } from '@progress/kendo-date-math';
import { environment } from 'src/environments/environment';

/*
* Prints message/object in console only if environment is not production
* */
export const logger = {
  e: (obj: any, ...optionalParams: any[]) => {
    if (!environment.production) console.error(obj, ...optionalParams);
  },
  w: (obj: any, ...optionalParams: any[]) => {
    if (!environment.production) console.warn(obj, ...optionalParams);
  },
  t: (obj: any, tabularData: any, properties?: string[] | undefined) => {
    if (!environment.production) {
      console.log(obj.toString());
      console.table(tabularData, properties);
    }
  },
  i: (obj: any, ...optionalParams: any[]) => {
    if (!environment.production) console.log(obj, ...optionalParams);
  }
};

export class Utils {
  static toServerDateFormat(date: MomentInput) {
    try {
      return moment(date).format('YYYY-MM-DD');
    } catch (e) {
      logger.e('toServerDateFormat', e);
      return null;
    }
  }

  static extractIds(idsString: string, separator = ',') {
    return idsString?.split(separator).map(Number).filter((v: any) => !isNaN(v)) || [];
  }


  static calcDaysDifference(startDate: Date, endDate: Date): number {
    const start = startDate;
    const end = endDate;
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    const oneDay = 24 * 60 * 60 * 1000;
    const diffInTime = end.getTime() - start.getTime();
    return Math.round(diffInTime / oneDay) + 1; // same day is 1 day
  }

  /*
  * Given a valid string of 7 binary digits, returns an array of the days that are active (1 = active, 0 = inactive)
  * */
  static getDays(binaryDates: string): Day[] {
    function moveLastCharToFirst(str: string): string {
      if (str.length <= 1) return str;
      return str.charAt(str.length - 1) + str.slice(0, str.length - 1);
    }
    const systemBinaryDates = moveLastCharToFirst(binaryDates);
    const days: Day[] = [];
    if (!/^[01]{7}$/.test(systemBinaryDates)) {
      logger.w(`Invalid binary dates: ${systemBinaryDates}`);
      return [];
    }

    for (let i = 0; i < systemBinaryDates.length; i++) {
      if (systemBinaryDates[i] === '1') {
        days.push(i);
      }
    }

    return days;
  }

  static getRandomElement<T>(array: T[]): T {
    const randomIndex = Math.floor(Math.random() * array.length);
    return array[randomIndex];
  }

  static encodeMailURIString(input: string): string {
    return input.replace(/ /g, '%20').replace(/\n/g, '%0D%0A');
  }


}
